import actions from '../../actionTypes';

export default (tag, areaId) => {
  return {
    type: actions.REMOVE_TAG,
    tag,
    areaId
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/removeTag.js